exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.skeletonLoader > .v-skeleton-loader__list-item\n{\n    height: 12px;\n}\n\n", ""]);
